import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { AuthService, EventsService, PaymentV2Service, StorageService, UtilService, VariablesService, VwoService } from '../../shared/services';
import { IPaymentSipConfig } from '../payment-sip/payment-sip.model';
import { AMOUNT_FORM } from '../payment/objects/amount.form';
import { GCaptchaComponent } from '../g-captcha/g-captcha.component';

@Component({
  selector: 'app-payment-sip-form',
  templateUrl: './payment-sip-form.component.html',
  styleUrls: ['./payment-sip-form.component.scss']
})
export class PaymentSipFormComponent implements OnInit, OnChanges {

  @Input() config: IPaymentSipConfig;
  @Output() dataEmit = new EventEmitter();
  @Output() setCurrency = new EventEmitter();
  @Output() formSubmitted = new EventEmitter();
  donationForm: FormGroup;
  info = AMOUNT_FORM;
  phoneNumber;
  oneTapOtpPopup: boolean;
  lives_count;
  exist_sip = [];
  cartData: any;

  @ViewChild(GCaptchaComponent, { static: true }) gCaptchaComponent: GCaptchaComponent;

  constructor(
    public dialog: MatDialog,
    public util: UtilService,
    private paymentV2: PaymentV2Service,
    private auth: AuthService,
    private vars: VariablesService,
    public vwo: VwoService,
    public events: EventsService,
    private storage: StorageService
  ) { }

  ngOnInit() {
    this.vars.selected_insurance = null;
    this.initForm();
    this.vars.trucallerRes.subscribe((res) => {
      this.donationForm.patchValue({
        name: res.name,
        email: res.email,
        mobile: res.phone
      });
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.config?.amount && this.config?.paymentDetails?.default_amount && (changes?.config?.currentValue?.amount !== changes?.config?.previousValue?.amount || changes?.config?.currentValue?.sip_cause)) {
      this.getChildCount(this.config?.amount * this.util.getLengthToMultiply(this.config?.sip_cause), this.config?.paymentDetails?.default_amount);
    }
  }

  initForm() {
    this.donationForm = new FormGroup({
      name: new FormControl('', [Validators.required, Validators.pattern(/^[a-z ,.'-]+$/i)]),
      email: new FormControl('', [Validators.required, Validators.pattern(this.vars.email_Pattern_Regex)]),
      mobile: new FormControl('', [Validators.required]),
    });
  }
  /**Get the child count */
  getChildCount(amount, default_amount) {
    if (amount && default_amount) {
      const children = Math.ceil(amount / default_amount) * 12;
      this.lives_count = children > 36 ? 36 : children;
    }
  }

  /** OTP varification for one tap payment */
  otpVerified = (isVarified) => {
    this.oneTapOtpPopup = isVarified;
    if (isVarified) {
      this.paymentV2.otpVerified = isVarified;
      this.createCart();
    }
  }

  submitPayment() {
    if (this.config.amount >= this.config.paymentDetails?.min_donation) {
      if (this.util.checkNestedObj(this.config, 'lastOrder.payment_gateway') &&
        this.config.lastOrder.payment_gateway.match('stripe') &&
        !this.oneTapOtpPopup &&
        this.config.currency !== 'INR'
      ) {
        this.oneTapOtpPopup = true;
        return;
      } else if (this.config.currency !== 'INR' && !this.paymentV2.captchaResponse && !this.paymentV2.otpVerified) {
        this.gCaptchaComponent.executeCaptcha();
        return;
      }
      !this.config.user ? this.submitForm() : this.createCart();
    }
  }

  submitForm() {
    if (this.donationForm.valid) {
      const payload = {
        full_name: this.donationForm.get('name').value,
        phone_1: this.donationForm.get('mobile').value,
        email: this.donationForm.get('email').value,
        extension: this.phoneNumber.extn
      };
      this.checkForExistingUser(payload);
    } else {
      this.util.checkValidForm(this.donationForm);
    }
  }

  async checkForExistingUser(payload) {
    this.paymentV2.isOrderLoading = true;
    try {
      const user = await this.auth.userLoginWithEmail(payload);
      this.paymentV2.paymentConfig.next({ user: user });
      await this.paymentV2.setUserLastOrder(user, this.config.paymentOptions.options);
      if (this.config.lastOrder && this.config.lastOrder.payment_gateway.match('stripe') && this.config.currency !== 'INR') {
        this.paymentV2.isOrderLoading = false;
        return;
      }
      this.createCart();
    } catch (error) {
      this.createCart(payload);
    }
  }

  async createCart(user?) {
    if (this.config.amount >= this.config.paymentDetails.min_donation) {
      if (typeof this.config.sip_cause === 'string') {
        this.config.sip_cause = [{ sip_cause: this.config.sip_cause, amount: this.config.amount }];
      } else if (!this.config.sip_cause) {
        this.config.sip_cause = [{ sip_cause: this.vars.default_sip_cause, amount: this.config.amount }];
      }
      const total_sip = this.paymentV2.totalSip(this.config.sip_cause, this.config);
      if (!total_sip.is_valid) { return; }
      const user_data = this.util.getUserData();
      this.exist_sip = Object.keys(user_data?.listsubscriptions||{});
      if (total_sip.only_cause_list.includes('sip_protect') && !total_sip.only_cause_list.includes('medical') && !this.exist_sip.includes('medical')) {
        return;
      }
      const cart_amount = total_sip?.total_amount || this.config.amount;
      let skipmin = false;
      if (cart_amount >= 1) {
        skipmin = true
      }
      const cartPayload = {
        campaign_id: this.config.paymentDetails.campaign.id,
        amount: cart_amount,
        currency: this.config.paymentDetails.selected_currency,
        is_anonymous: this.config.paymentDetails.is_anonymous,
        sip_cause: this.config.sip_cause,
        only_cause_list: total_sip.only_cause_list,
        user: user,
        sip_story: this.config.sip_story,
        skipmin: skipmin,
        recurring: !this.config.wallet_recharge ? 1 : null
      };

      if (this.vwo.sip_campaign_DM_AB()) {
        cartPayload['campaign_id'] = this.config?.campaign_id;
      }

      if (this.config.enable_multicause_slection) {
        cartPayload['multicause'] = true;
      }

      if (this.config.sip_story) {
        cartPayload['transaction_type'] = null;
      } else if (this.config.sip_wallet) {
        cartPayload['transaction_type'] = `wallet_new_sip_${this.config.wallet_tenure}`;
      } else if (this.config.auto_pay_m1) {
        cartPayload['transaction_type'] = 'new_sip_amt_1';
      }

      if (this.config.enable_multicause_slection) {
        cartPayload['multicause'] = true;
      }

      this.cartData = await this.paymentV2.createCart(cartPayload);
      this.paymentV2.paymentConfig.next({ cart: this.cartData.cart, fundraiser: this.cartData.fundraiser });
      if (
        this.util.checkNestedObj(this.config, 'lastOrder.payment_gateway') &&
        this.config.lastOrder.payment_gateway.match('stripe') &&
        this.config.currency !== 'INR'
      ) {
        this.oneTapCardPayment();
        return;
      }
      if (!this.config.redirectTo) {
        this.formSubmitted.emit(true);
      }
      this.redirectToPaymentPage();
    }
  }

  oneTapCardPayment() {
    this.dataEmit.emit({
      mode: 'CARD',
      card_name_fill: this.config.user.full_name,
      mode_value: this.config.lastOrder.payment_mode_value,
      customer_id: this.config.lastOrder.payment_details.customer_id
    });
    return true;
  }

  redirectToPaymentPage() {
    this.paymentV2.isOrderLoading = false;
    if (this.config.redirectTo) {
      let redirectTo = '';
      const queryParams = {
        amt: this.config.cart_amount,
        currency: this.config.currency,
        campaign_id: this.cartData?.cart?.campaign_id || this.config.paymentDetails.campaign.id,
        is_multicause: this.config.enable_multicause_slection || null,
        min_donation: this.config.paymentDetails.min_donation
      };
      if (this.config.sip_cause) {
        queryParams['sip_cause'] = this.util.jsonToString(this.config.sip_cause);
      }
      if (this.config.frequency_term) {
        queryParams['frequency'] = this.config.frequency;
      }
      if (this.config.redirectTo === 'welcome') {
        queryParams['last_pay_mode'] = this.config.lastOrder.payment_mode;
        redirectTo = '/new/sip/welcome';
      } else if (this.config.redirectTo === 'standalone') {
        redirectTo = '/new/sip/payment-standalone';
        if (!this.redirectErrorCheck('standalone')) {
          return false;
        }
      }
      this.util.router.navigate([redirectTo], { queryParams: queryParams, queryParamsHandling: 'merge' });
      this.dialog.closeAll();
    } else {
      this.util.router.navigate([], { queryParams: { page: 'op' }, queryParamsHandling: 'merge' });
    }
  }

  emitConfig(amount) {
    this.paymentV2.paymentConfig.next({ amount: amount });
    if (typeof this.config?.sip_cause === 'object') {
      this.config?.sip_cause.forEach((element, i) => {
        this.config.sip_cause[i] = { sip_cause: element?.sip_cause, amount: amount }
      });
    }
  }

  captchaResponse(e) {
    this.paymentV2.captchaResponse = e;
    this.submitPayment();
  }

  setFrequency(e) {
    this.paymentV2.paymentConfig.next({ frequency: e });
  }

  redirectErrorCheck(to) {
    const notSupported = this.config?.sip_cause?.filter(val => ['elderly', 'women_girls'].includes(val.sip_cause))[0];
    if (to === 'standalone' && notSupported && this.config.currency !== 'INR') {
      this.util.openSnackBar('The selected cause only supports INR monthly donations', 'error');
      this.paymentV2.isOrderLoading = false;
      return false;
    }
    return true;
  }

  slabFirstFlowSubmit() {
    const payload = {
      eventName: 'dm-campaign-select',
      info_4: this.config?.slabs_first_flow_name?.id
    };
    this.events?.sendSystemEvent(payload).subscribe(_ => _);
    this.paymentV2.paymentConfig.next({ slabs_first_flow: false, showSlabs: false, amount: this.config?.amount });
  }
}
